if (!customElements.get('road-spec-vehicle-parts')) {
  customElements.define(
    'road-spec-vehicle-parts',
    class RoadSpecVehicleParts extends HTMLElement {
      connectedCallback() {
        this.load();
      }

      async load() {
        const target = this.querySelector('[data-rsp-vehicle-target]');
        const status = this.querySelector('[data-rsp-vehicle-status]');
        if (!target || !this.dataset.endpoint) return;

        try {
          const response = await fetch(this.dataset.endpoint, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Vehicle parts request failed: ${response.status}`);
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = documentFragment.querySelector('[data-rsp-vehicle-results]');
          if (!results) throw new Error('Vehicle parts response did not include results');

          const currentProductId = this.dataset.currentProductId;
          const limit = Number(this.dataset.limit) || 4;
          const items = Array.from(results.querySelectorAll('[data-product-id]'));
          items.forEach((item) => {
            if (item.dataset.productId === currentProductId) item.remove();
          });
          Array.from(results.querySelectorAll('[data-product-id]')).slice(limit).forEach((item) => item.remove());

          const remaining = results.querySelectorAll('[data-product-id]').length;
          if (remaining === 0) {
            this.hidden = true;
            return;
          }

          target.replaceChildren(...results.childNodes);
          target.setAttribute('aria-busy', 'false');
          status.textContent = `${remaining} related vehicle-family parts loaded.`;
        } catch (error) {
          target.setAttribute('aria-busy', 'false');
          target.innerHTML = '<p class="rsp-vehicle-parts__empty">Use “View all” to browse this vehicle family.</p>';
          status.textContent = 'Related vehicle-family parts could not be loaded.';
          console.warn(error);
        }
      }
    },
  );
}
